// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-input.started-webinar-title-field .v-input__append-inner {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-top: 0 !important;\n  height: 100%;\n}\n.webinar-title-update-info-text {\n  text-align: initial;\n  margin-top: 10px;\n}\n.webinar-title-update-info-text--success {\n  color: var(--v-success-base);\n}\n.webinar-title-update-info-text--error {\n  color: var(--v-error-base);\n}", ""]);
// Exports
module.exports = exports;
